import {
  ADDBIKEDETAILS,
  ADDBIKENUMBER,
  ALLBIKEDETAILS,
  BIKENUMFLAG,
  BIKE_INS_PRODUCT,
  BIKEQUICKQUOTES,
  BIKE_PREV_INS_LIST,
  CUSTOMER_DETAILS,
  ADD_VAHAN_DATA,
  CREATE_PROPOSAL,
  PAYMENT_REQUEST,
  SET_IDV,
  QUICKQUOTE_POST,
  QUICKQUOE_VALUE,
  KYC_STATUS,
  POLICY_PDF,
  POSP_DATA,
  POSP_BIKENUM,
  Posp_DETAILS,
  Posp_SINGLE_QUOTE,
  PREV_POLICY_DETAIL,
  SAVE_PASS,
  SELECTED_QUOTE,
  COMPARE_QQ,
  ERROR_QUOTES,
  UAT_LOGIN,
  SELECTED_ADDONS,
  TRANS_ID,
  ROUTE,
  SHORTLIST_QQ,
  TOKEN_EXPIRED,
  SEND_REQUEST,
  OTP_SENT,
  ADD_PRODUCT_TYPE,
} from "../actiontypes/NumBikeActiontypes";
import axiosInstance from "../axios/AxiosInstance";
import axiosInPosp from "../axios/AxiosInPosp";

export function OnSendReq(data) {
  return {
    type: SEND_REQUEST,
    payload: data,
  };
}
export function SelectAddons(data) {
  return {
    type: SELECTED_ADDONS,
    payload: data,
  };
}
export function GetPosp(data) {
  return {
    type: POSP_DATA,
    payload: data,
  };
}
export function GetPrevPolicy(data) {
  return {
    type: PREV_POLICY_DETAIL,
    payload: data,
  };
}
export function PospDetails(data) {
  return {
    type: Posp_DETAILS,
    payload: data,
  };
}
export function QuickQuote_Post(data) {
  return {
    type: QUICKQUOTE_POST,
    payload: data,
  };
}
export function SingleQuote(data) {
  return {
    type: Posp_SINGLE_QUOTE,
    payload: data,
  };
}
export const CustomerDetails = (data) => {
  return {
    type: CUSTOMER_DETAILS,
    payload: data,
  };
};
export const numBikeflagfalse = () => {
  return {
    type: BIKENUMFLAG,
  };
};
export const allbikedetails = () => {
  return {
    type: ALLBIKEDETAILS,
  };
};
export const addbikenum = (data) => {
  return {
    type: ADDBIKENUMBER,
    payload: data,
  };
};
export const PospBikenum = (data) => {
  return {
    type: POSP_BIKENUM,
    payload: data,
  };
};
export const PospSavePass = (data) => {
  return {
    type: SAVE_PASS,
    payload: data,
  };
};
export const Create_proposal = (data) => {
  return {
    type: CREATE_PROPOSAL,
    payload: data,
  };
};
export const setIDV = (data) => {
  return {
    type: SET_IDV,
    payload: data,
  };
};
export const Payment_Request = (data) => {
  return {
    type: PAYMENT_REQUEST,
    payload: data,
  };
};

export const KYC_Status = (data) => {
  return {
    type: KYC_STATUS,
    payload: data,
  };
};
export const Policy_PDF = (data) => {
  return {
    type: POLICY_PDF,
    payload: data,
  };
};
export const addVahanData = (data) => {
  return {
    type: ADD_VAHAN_DATA,
    payload: data,
  };
};
export const addbikedetails = (data) => {
  return {
    type: ADDBIKEDETAILS,
    payload: data,
  };
};
export function insurance_product_action(devices) {
  return {
    type: BIKE_INS_PRODUCT,
    payload: devices,
  };
}

export function previous_insurance_list(devices) {
  return {
    type: BIKE_PREV_INS_LIST,
    payload: devices,
  };
}
export function quick_quoteValues(data) {
  return {
    type: QUICKQUOE_VALUE,
    payload: data,
  };
}
export function quick_quotes_Bike(data) {
  return {
    type: BIKEQUICKQUOTES,
    payload: data,
  };
}
export function Err_quotes(data) {
  return {
    type: ERROR_QUOTES,
    payload: data,
  };
}
export function selected_quote(data) {
  return {
    type: SELECTED_QUOTE,
    payload: data,
  };
}
export function Compare_quote(data) {
  return {
    type: COMPARE_QQ,
    payload: data,
  };
}
export function ShortListQuote(data) {
  return {
    type: SHORTLIST_QQ,
    payload: data,
  };
}
export function SaveTransID(data) {
  return {
    type: TRANS_ID,
    payload: data,
  };
}
export function SelectedRoute(data) {
  return {
    type: ROUTE,
    payload: data,
  };
}
export function UatLogin(data) {
  return {
    type: UAT_LOGIN,
    payload: data,
  };
}
export function TokenExpired(data) {
  return {
    type: TOKEN_EXPIRED,
    payload: data,
  };
}
export function OnOtpSend(data) {
  return {
    type: OTP_SENT,
    payload: data,
  };
}
export function addProductType(data) {
  return {
    type: ADD_PRODUCT_TYPE,
    payload: data,
  };
}
export const GetQuotes = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInPosp
        .get("v1/posp/quick_quotes")
        .then(function (response) {
          // console.log("insurance_product", response);
          let QuotesList = response?.data;
          //dispatch(FetchQuotes(QuotesList));
          resolve(QuotesList);
        })
        .catch(function (error) {
          console.log(error.response.data.message);
          if (error.response.data.message === "Unauthenticated.") {
            dispatch((dispatch) => {
              dispatch({ type: "RESET_STATE" });
              dispatch({ type: "LOGOUT_POSP" });
            });
            // return <Link to="/" />;
            window.location.href = "/";
          }
          reject(error);
        });
    });
  };
};
export const insuranceproduct = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("insurance_product/2")
        .then(function (response) {
          // console.log("insurance_product", response);
          dispatch(insurance_product_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error.response.data.message);
          // if (error.response.data.message === "Unauthenticated.") {
          //   dispatch({ type: "RESET_BIKE" });
          // }
          reject(error);
        });
    });
  };
};
export const financierList = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("financier_list")
        .then(function (response) {
          // console.log(response);
          //dispatch(insurance_product_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error.response);
          reject(error);
        });
    });
  };
};

export const Previousinsurer = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("previous_insurer_list")
        .then(function (response) {
          // console.log(response);
          dispatch(previous_insurance_list(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error.message);
          reject(error);
        });
    });
  };
};
